import { AxiosInstance } from 'axios';
import { BaseApi } from 'services/api/base-api';
import { ApiResult } from 'services/api/result.type';
import { GetIntercomSettingsResponse } from './dto';

export class IntercomApi extends BaseApi {
  public constructor(protected readonly api: AxiosInstance) {
    super();

    this.getIntercomSettings = this.getIntercomSettings.bind(this);
  }

  public async getIntercomSettings(): ApiResult<GetIntercomSettingsResponse> {
    return await this.get<GetIntercomSettingsResponse>(
      '/intercom/settings',
      {},
      { redirectOn401: false },
    );
  }
}
